export default {
  light: {
    backgroundColor: 'white',
    borderColor: '#acacac40',
    textSizeNormal: '14px',
    textSizeLarge: '18px',
    primaryColor: '#1890ff',
    normalTextColor: '#9B9B9B',
  },
  dark: {
    backgroundColor: 'black',
    borderColor: '#acacac40',
    textSizeNormal: '14px',
    textSizeLarge: '18px',
    primaryColor: '#1890ff',
    normalTextColor: '#9B9B9B',
  },
};
